<!-- <div class="container-flex w-100 not-selectable d-none d-lg-block" id="book-digital-container" -->
<div class="container-flex w-100 not-selectable d-block" id="book-digital-container"
  style="height: 100%!important; overflow-y: hidden; overflow-x: hidden;"
  *ngIf='bookStatus!=null && (bookStatus==BookStatus.READY || bookStatus==BookStatus.EXPIRED)' oncontextmenu="false;">

  <!-- <app-check-access [token]='token' [accessToken]="accessToken" [externalToken]="externalToken" (grantAccess)="accessGranted=true;loadBook()"
    *ngIf="!accessGranted" (tokenChange)="token=$event"> 
  </app-check-access> -->

  <app-book-pdf-flipbook-landscape *ngIf="!isPageVertical && bookStatus==BookStatus.READY"
    [token]="token">
  </app-book-pdf-flipbook-landscape>
  <app-book-pdf-flipbook-vertical *ngIf="isPageVertical && bookStatus==BookStatus.READY"
    [token]="token">
  </app-book-pdf-flipbook-vertical>

  <!-- <app-floating-tips *ngIf="false" [step]='tipsStep' (continue)="onNextTip()">
  </app-floating-tips> -->

    <ng-container *ngIf='bookStatus==BookStatus.EXPIRED'>
    <div class="card">
      <h4 class="card-header">Se ha vuelto a solicitar el estudio</h4>
      <div class="card-body" style="padding:1rem;">
        <span class="row g-0 font-responsive" *ngIf="!canRenewBook">
          El estudio al que está intentando acceder ya es antiguo y se debe volver a preparar. Este proceso puede tardar unos minutos.
        </span>
        <span class="row g-0 font-responsive" *ngIf="canRenewBook">
          Cuando el estudio vuelva a estar disponible, se recargará la página automáticamente. O si lo desea, puede cerrar esta ventana y volver a acceder más tarde.
        </span>
      </div>
    </div>
  </ng-container>
</div>

<ng-container *ngIf='bookStatus!=null && (bookStatus==BookStatus.NOT_READY || bookStatus==BookStatus.DELETED)'>
  <div class="card">
    <h4 class="card-header">Book Digital no disponible</h4>
    <div class="card-body text-center" style="padding:1rem;">
      <span class="row g-0 font-responsive">
        Este estudio todavía no ha sido publicado.
      </span>
      <span class="row g-0 font-responsive">
        Por favor, espere a que su centro finalice la publicación.
      </span>
    </div>
  </div>
</ng-container>